import { Component, OnInit } from '@angular/core';
import { UserProfile } from './models/user-profile';
import { Observable, delay, of } from 'rxjs';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { MessageService, TreeNode } from 'primeng/api';
import { UserService } from './user.service';
import { UserProfileConstants } from './user-profile-constants';
import { MySpaceConstants } from '../my-space-constants';
import { UserProfileTabAccess } from './models/userProfileTabAccess';
import { LabelConstants } from '../../shared/constants/label-constants';
import { EmployeesTrainingPlanService } from '../employees-training-plan/services/employees-training-plan.service';
import { EmployeeDetails } from '../employees-training-plan/models/employee-details';
import { ActivatedRoute } from '@angular/router';
import { DefaultValueConstants } from '../../shared/constants/default-value-constants';
import { SharedConstants } from '../../../app/shared/constants/shared-constants';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit{
  
  
  topBarTitle:string = MySpaceConstants.UserProfileTopBarTitle;
  maxFileSize = MySpaceConstants.Attachment_File_Max_Size;
  items = [MySpaceConstants.UserProfileTabName, MySpaceConstants.TrainingProfileTabName];
  userProfile: UserProfile = {} as UserProfile;
  files: File[] = [];
  alleQMSScope:any[] = [];
  treeData: TreeNode[] = [];
  showConfirmationModal:boolean = false;
  confirmationMessage:string = UserProfileConstants.ConfirmationMessage;
  deleteAttachmentId:string|undefined;
  accessToUserProfile = false;
  userProfileAcessErrorMessage!:string;
  userProfileTabAccess!: UserProfileTabAccess;
  userProfileAttachmentMaxLimit= SharedConstants.AttachmentMaxLimit;
  toastKey: string = UserProfileConstants.UserProfileToastKey;
  
  constructor(private router: ActivatedRoute, private employeesTrainingPlanService: EmployeesTrainingPlanService, private eqmsScopeManagementService: EqmsScopeManagementService, private userService: UserService, 
    private messageService : MessageService){}
  notApplicableText = UserProfileConstants.NotApplicable;
  trainingPlanReviewPendingCount = 0;
  userProfileActiveTabIndex: number = 0; 
  activeTab : string = UserProfileConstants.UserProfileTab;



  ngOnInit(): void {
    this.messageService.clear(this.toastKey);
    this.router.queryParams.subscribe((queryParams:any) => {
      this.activeTab = queryParams.activeTab;
      if (this.activeTab === UserProfileConstants.MyEmployeesTab) {
        this.userProfileActiveTabIndex = 2;
      } else {
        this.userProfileActiveTabIndex = 0;
      }
     }
    );

    this.userService.getUserProfileAuthentication().subscribe({
      next: (serviceData) => {
        this.accessToUserProfile = true;
        this.userProfileTabAccess = serviceData;
        this.loadUserProfile();
      },
      error: (err) => {
        this.accessToUserProfile = false;
        if(err.status === LabelConstants.Forbidden_StatusCode)
          this.userProfileAcessErrorMessage = err.error.detail;
      }
    });
  } 

  ngOnDestroy(): void {
  // Clear messages when component is destroyed
  this.messageService.clear(this.toastKey);
}

  getPendingStatusCount(employeeDetails: EmployeeDetails[]): number {
    let count = 0;
    for (const employee of employeeDetails) {
      if (employee.status === DefaultValueConstants.pending_label) {
        count++;
      }
    }
    return count;
  }

  updateTrainingPlanReviewPendingCount(count: number) {
    this.trainingPlanReviewPendingCount = count;
  }
  
  loadUserProfile(){
    var puid = sessionStorage['puid'] != null ? sessionStorage['puid'] : null;
    this.userService.getUserByPuid(puid).subscribe((userProfileDetails)=>{
      this.userProfile = userProfileDetails;
      if(this.userProfile.directReporties === null 
        ||this.userProfile.directReporties === undefined 
        || this.userProfile.directReporties?.length === 0){
        this.userProfile.directReporties = [];
        this.userProfile.directReporties.push(this.notApplicableText);
      }
      this.loadeQMSScope();
    });
}

loadeQMSScope(){
  this.eqmsScopeManagementService.getEQMSScope().subscribe((eQMSScope)=>{
    this.alleQMSScope = eQMSScope;
    //If both primary eQMSScope and selectede QMSScope are null - (in terminated User Condition). no need to construct tree Node for Scopes
    if(this.userProfile.primaryeQMSScopeId !== null || (Array.isArray(this.userProfile.selectedeQMSScopeIds) && this.userProfile.selectedeQMSScopeIds.length > 0)){
      this.treeData.push({
        label: eQMSScope.eQMSScopeName,
        icon: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === eQMSScope.eQMSScopeId) ? UserProfileConstants.PrimaryeQMSScopeIcon : undefined,
        
        styleClass:  (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === eQMSScope.eQMSScopeId) 
        || this.userProfile.selectedeQMSScopeIds?.some(e=>e === eQMSScope.eQMSScopeId)
        ? UserProfileConstants.SelectedeQMSScopeStyleClass
        : UserProfileConstants.UnselectedeQMSScopeStyleClass,

        children: eQMSScope.children
          ? this.updateTreeNodes(eQMSScope.children)
          : undefined,
          expanded : true
      });
    }
  })
}

uploadSucceeds = (uploadedFiles: File[]): Observable<string[]> => {
  this.files = [...this.files, ...uploadedFiles];
  
  uploadedFiles.forEach((file) => {
    const modifiedFile = new File(
      [file], 
      this.userProfile.puid + '/' + file.name, 
      { type: file.type }
    );
    
    this.userService.uploadFile(modifiedFile, UserProfileConstants.UserProfileAttachmentFolderName)
      .subscribe({
        next: (response) => {
          const attachmentDetails = {
            attachmentFileType: response.fileExtension,
            fileId: response.fileId,
            attachmentFilePath: modifiedFile.name,
            attachmentFileName: file.name,
          };
          
          this.userService.addAttachment(this.userProfile.puid, attachmentDetails)
            .subscribe({
              next: () => {
                // Get attachment details, and reload data on the screen
                this.reloadAttachments();
              },
              error: (err) => {
                const validationMessage = `Failed to add attachment: ${file.name}`;
                this.messageService.add({
                  key: this.toastKey,
                  severity: UserProfileConstants.Severity_Err,
                  summary: validationMessage,
                  detail: err || 'Failed to add attachment details',
                  sticky: true
                });
              }
            });
        },
        error: (err) => {
          const validationMessage = `Failed to upload file: ${file.name}`;
          this.messageService.add({
            key: this.toastKey,
            severity: UserProfileConstants.Severity_Err,
            summary: validationMessage,
            detail: err || 'Failed to upload file',
            sticky: true
          });
        }
      });
  });
  
  const fileNames = uploadedFiles.map((i) => i.name);
  return of(fileNames).pipe(delay(3000));
};


deleteAttachment(attachmentId:string){
  this.showConfirmationModal = true;
  this.deleteAttachmentId = attachmentId;
}


updateTreeNodes(nodes: any): any[] {
  const children: any[] = nodes.map((childNode: any) => {
    const shouldLoadChildren = this.shouldLoadChildrenNodes(childNode.children ?? [], false);
    return (this.shouldLoadSiblingNodes(childNode, false) || shouldLoadChildren) ? {
      label: childNode.eQMSScopeName,
      icon: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === childNode.eQMSScopeId)
        ? UserProfileConstants.PrimaryeQMSScopeIcon 
        : undefined,
      styleClass: (this.userProfile.primaryeQMSScopeId !== null && this.userProfile.primaryeQMSScopeId === childNode.eQMSScopeId) 
        || this.userProfile.selectedeQMSScopeIds?.includes(childNode.eQMSScopeId)
          ? UserProfileConstants.SelectedeQMSScopeStyleClass 
          : UserProfileConstants.UnselectedeQMSScopeStyleClass,
      children: shouldLoadChildren
        ? this.updateTreeNodes(childNode.children ?? [])
        : undefined,
      expanded: true
    } : undefined;
  }).filter((node: any): node is any => node !== undefined);
  
  return children;
}

shouldLoadChildrenNodes(nodes: any[], shouldLoad: boolean): boolean {
  for (const childNode of nodes) {
    if ( (this.userProfile.primaryeQMSScopeId !== null && childNode.eQMSScopeId === this.userProfile.primaryeQMSScopeId) 
      || this.userProfile.selectedeQMSScopeIds?.includes(childNode.eQMSScopeId)) {
      return true;
    }
    if (childNode.children) {
      if (this.shouldLoadChildrenNodes(childNode.children, shouldLoad)) {
        return true;
      }
    }
  }
  return shouldLoad;
}

shouldLoadSiblingNodes(node: any, shouldLoad: boolean): boolean {
  return (this.userProfile.primaryeQMSScopeId !== null && node.eQMSScopeId === this.userProfile.primaryeQMSScopeId) 
    || this.userProfile.selectedeQMSScopeIds?.includes(node.eQMSScopeId) 
    ? true : shouldLoad;
}


private reloadAttachments(){
  setTimeout(()=>{
    this.userService.getAttachmentsForUser(this.userProfile.puid).subscribe((result)=>{
      this.userProfile.attachments = result;
  })
  }, 3000);
}

  userProfileErrorMessage() : string {
    if (!this.accessToUserProfile) {
      return this.userProfileAcessErrorMessage;
    }
    return UserProfileConstants.UserProfile_RoleAcessPermission_Fail;
  }
}
